/* V4NGUARD waitlist — one controller for the waitlist-* sections.
   Each section only renders markup; this file finds whichever pieces are on the page
   (film, corners, lockup, sign-up, password dialog) and runs the sequence:
   intro film → blur → sign-up opens → lockup when closed.
   Every section includes this script, so it guards against running twice. */
(function () {
  if (window.V4NWaitlist) return;

  var body = document.body;
  var INTRO_SEEN_KEY = "v4n_intro_seen";

  var store = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  };
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function escapeHtml(s) { return String(s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }

  var strings = null;
  function t(key) {
    if (!strings) {
      var el = $("[data-wl-strings]");
      try { strings = el ? JSON.parse(el.textContent) : {}; } catch (e) { strings = {}; }
    }
    return strings[key] || "";
  }

  // ---------- Film ----------
  // Portrait screens get the 9:16 cut so it fills the page; the 720p renditions on data saver / small landscape.
  var saveData = navigator.connection && navigator.connection.saveData;
  var portraitMq = window.matchMedia("(max-aspect-ratio: 1/1)");
  var smallMq = window.matchMedia("(max-width: 900px)");
  var portrait = portraitMq.matches;
  var raf = 0;

  function video() { return $("[data-wl-video]"); }

  function pickSource(v) {
    var key = portrait ? "portrait" : "landscape";
    v.poster = v.getAttribute("data-poster-" + key);
    var small = saveData || (!portrait && smallMq.matches);
    return v.getAttribute("data-" + key + (small ? "-small" : "-full"));
  }

  function setupFilm() {
    var v = video();
    if (!v || v.wlReady) return;
    v.wlReady = true;
    portrait = portraitMq.matches;
    v.src = pickSource(v);
    v.addEventListener("ended", function () { endIntro(); });
  }

  // Rotating the device swaps cuts, keeping the playhead.
  function onOrientation() {
    var v = video();
    if (!v || portraitMq.matches === portrait) return;
    portrait = portraitMq.matches;
    var at = v.currentTime, playing = !v.paused;
    v.src = pickSource(v);
    v.addEventListener("loadedmetadata", function seek() {
      v.removeEventListener("loadedmetadata", seek);
      v.currentTime = at;
      if (playing) v.play().catch(function () {});
    });
  }
  window.addEventListener("resize", onOrientation);
  window.addEventListener("orientationchange", onOrientation);

  function tick() {
    var v = video(), bar = $("[data-wl-progress]");
    if (v && bar && v.duration) bar.style.transform = "scaleX(" + (v.currentTime / v.duration) + ")";
    raf = requestAnimationFrame(tick);
  }

  function startIntro() {
    var v = video();
    if (!v) { endIntro(); return; }
    body.classList.remove("wl-post", "wl-modal-closed");
    v.loop = false;
    v.currentTime = 0;
    var p = v.play();
    if (p && p.catch) p.catch(function () { endIntro(); }); // autoplay blocked → straight to the offer
    cancelAnimationFrame(raf); tick();
  }

  function playLoop() {
    var v = video();
    if (!v) return;
    v.loop = true;
    v.currentTime = 0;
    var p = v.play();
    if (p && p.catch) p.catch(function () {
      // Playback blocked (low-power mode, strict autoplay policy): hold on a still
      // frame and start the loop on the visitor's first interaction.
      var film = $("[data-wl-film]");
      v.currentTime = parseFloat(film && film.getAttribute("data-hold")) || 0;
      var events = ["pointerdown", "keydown", "touchstart"];
      var resume = function () {
        v.play().catch(function () {});
        events.forEach(function (ev) { document.removeEventListener(ev, resume); });
      };
      events.forEach(function (ev) { document.addEventListener(ev, resume, { passive: true }); });
    });
  }

  function endIntro(opts) {
    opts = opts || {};
    if (body.classList.contains("wl-post")) return;
    cancelAnimationFrame(raf);
    body.classList.add("wl-post");
    store.set(INTRO_SEEN_KEY, "1");
    playLoop();

    var m = modal();
    var autoOpen = m && m.getAttribute("data-auto-open") === "true";
    if (opts.openModal === false) return;
    if (autoOpen) setTimeout(openModal, opts.delay == null ? 900 : opts.delay);
    else body.classList.add("wl-modal-closed"); // no auto-open: rest on the lockup
  }

  // ---------- Sign-up modal ----------
  function modal() { return $("[data-wl-modal]"); }
  function storeKey() { var m = modal(); return (m && m.getAttribute("data-store-key")) || "v4n_enlisted"; }
  function saved() { try { return JSON.parse(store.get(storeKey())); } catch (e) { return null; } }
  var lastFocus = null;

  function openModal() {
    var m = modal();
    if (!m || body.classList.contains("wl-modal-open")) return;
    var s = saved();
    if (s) showSuccess(s);
    lastFocus = document.activeElement;
    body.classList.remove("wl-modal-closing", "wl-modal-closed");
    void m.offsetWidth; // restart CSS animations
    body.classList.add("wl-modal-open");
    setTimeout(function () {
      var target = m.classList.contains("is-success")
        ? ($('[data-wl-action="copy"]', m) || $('[data-wl-action="close"]', m))
        : $("[data-wl-email]", m);
      if (target) target.focus({ preventScroll: true });
    }, 1200);
  }

  function closeModal(silent) {
    if (!body.classList.contains("wl-modal-open")) return;
    body.classList.add("wl-modal-closing");
    setTimeout(function () {
      body.classList.remove("wl-modal-open", "wl-modal-closing");
      if (silent) return;
      body.classList.add("wl-modal-closed");
      var reopen = $('[data-wl-action="reopen"]');
      if (reopen) reopen.focus({ preventScroll: true });
      else if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }, 700);
  }

  function showSuccess(p) {
    var m = modal();
    if (!m) return;
    var joined = $("[data-wl-joined]", m);
    if (joined && p && p.email) {
      var tpl = p.phone ? t("joinedPhone") : t("joined");
      joined.innerHTML = tpl
        .replace("[email]", escapeHtml(p.email))
        .replace("[phone]", p.phone ? escapeHtml(formatPhone(p.phone.slice(2))) : "") + " ";
    }
    m.classList.add("is-success");
    setReopenLabel(true);
  }

  function setReopenLabel(joined) {
    var b = $('[data-wl-action="reopen"]');
    if (!b) return;
    var label = b.getAttribute(joined ? "data-label-joined" : "data-label");
    if (label) b.textContent = label;
  }

  // ---------- Store password dialog ----------
  function openPassword() {
    if (!$("[data-wl-pw-wrap]")) return;
    if (body.classList.contains("wl-modal-open")) closeModal(true);
    body.classList.add("wl-pw-open");
    setTimeout(function () { var i = $('[data-wl-pw-wrap] input[name="password"]'); if (i) i.focus(); }, 50);
  }
  function closePassword() {
    body.classList.remove("wl-pw-open");
    var b = $('[data-wl-action="password-open"]');
    if (b) b.focus({ preventScroll: true });
  }

  // ---------- Form ----------
  function digits(v) { return v.replace(/\D/g, "").replace(/^1(?=\d{10})/, "").slice(0, 10); }
  function formatPhone(d) {
    if (d.length < 4) return d;
    if (d.length < 7) return "(" + d.slice(0, 3) + ") " + d.slice(3);
    return "(" + d.slice(0, 3) + ") " + d.slice(3, 6) + "-" + d.slice(6);
  }
  function setErr(form, name, msg) {
    var f = $('[data-wl-field="' + name + '"]', form);
    if (!f) return;
    f.classList.toggle("is-invalid", !!msg);
    $(".wl-err", f).textContent = msg;
  }
  function setFormError(form, msg) {
    var el = $("[data-wl-form-error]", form);
    if (el) el.textContent = msg || "";
  }

  // Shopify sometimes answers with a captcha challenge; that page needs a real navigation.
  function nativeSubmit(form) {
    form.setAttribute("data-wl-native", "");
    HTMLFormElement.prototype.submit.call(form);
  }

  function onSubmit(e) {
    var form = e.target.closest("[data-wl-form]");
    if (!form || form.hasAttribute("data-wl-native")) return;
    e.preventDefault();

    var emailEl = $("[data-wl-email]", form);
    var phoneEl = $("[data-wl-phone]", form);
    var consentEl = $("[data-wl-consent]", form);
    var email = emailEl.value.trim();
    var d = phoneEl ? digits(phoneEl.value) : "";
    var ok = true;

    setFormError(form, "");
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { setErr(form, "email", t("emailInvalid")); ok = false; }
    if (d.length && d.length !== 10) { setErr(form, "phone", t("phoneInvalid")); ok = false; }
    if (d.length === 10 && !consentEl.checked) { $("[data-wl-consent-row]", form).classList.add("is-invalid"); ok = false; }
    if (!ok) {
      var bad = $(".is-invalid input", form);
      if (bad) bad.focus();
      return;
    }

    // Shopify's customer form only stores email, so the phone and text consent travel as customer tags.
    var payload = { email: email, phone: d.length === 10 ? "+1" + d : null };
    var tagsEl = $("[data-wl-tags]", form);
    if (!tagsEl.hasAttribute("data-base")) tagsEl.setAttribute("data-base", tagsEl.value);
    var tags = tagsEl.getAttribute("data-base");
    if (payload.phone) tags += ",sms-optin,phone-" + payload.phone;
    tagsEl.value = tags;
    emailEl.value = email;

    var btn = $("[data-wl-submit]", form);
    var label = btn.textContent;
    btn.disabled = true; btn.textContent = t("submitting") || label;
    var reset = function () { btn.disabled = false; btn.textContent = label; };

    fetch(form.action, { method: "POST", body: new FormData(form), credentials: "same-origin", headers: { Accept: "text/html" } })
      .then(function (res) {
        if (/\/challenge/.test(res.url)) { nativeSubmit(form); return; }
        if (/customer_posted=true/.test(res.url)) { done(); return; }
        return res.text().then(function (html) {
          var doc = new DOMParser().parseFromString(html, "text/html");
          var st = $("[data-wl-state]", doc);
          if (st && st.getAttribute("data-wl-state") === "success") { done(); return; }
          var err = $("[data-wl-form-error]", doc);
          var msg = err && err.textContent.trim();
          if (msg) { reset(); setFormError(form, msg); emailEl.focus(); }
          else nativeSubmit(form); // unrecognised answer: let the browser handle it
        });
      })
      .catch(function () { reset(); setFormError(form, t("network")); });

    function done() {
      store.set(storeKey(), JSON.stringify(payload));
      reset();
      form.reset();
      $("[data-wl-consent-row]", form) && $("[data-wl-consent-row]", form).classList.remove("is-shown");
      showSuccess(payload);
      var focus = $('[data-wl-action="copy"]') || $('[data-wl-action="close"]');
      if (focus) focus.focus();
    }
  }

  document.addEventListener("submit", onSubmit);

  document.addEventListener("input", function (e) {
    var form = e.target.closest("[data-wl-form]");
    if (!form) return;
    if (e.target.matches("[data-wl-phone]")) {
      var d = digits(e.target.value);
      e.target.value = formatPhone(d);
      var row = $("[data-wl-consent-row]", form);
      if (row) row.classList.toggle("is-shown", d.length > 0);
      setErr(form, "phone", "");
    } else if (e.target.matches("[data-wl-email]")) {
      setErr(form, "email", "");
      setFormError(form, "");
    }
  });

  document.addEventListener("change", function (e) {
    if (e.target.matches("[data-wl-consent]")) e.target.closest("[data-wl-consent-row]").classList.remove("is-invalid");
  });

  // ---------- Buttons ----------
  var actions = {
    skip: function () { endIntro(); },
    replay: function () {
      if (body.classList.contains("wl-modal-open")) closeModal(true);
      startIntro();
    },
    close: function () { closeModal(); },
    reopen: openModal,
    "password-open": openPassword,
    "password-close": closePassword,
    copy: function (b) {
      var code = $("[data-wl-code]");
      var copied = function () {
        b.textContent = t("copied");
        setTimeout(function () { b.textContent = t("copy"); }, 1600);
      };
      if (code && navigator.clipboard) navigator.clipboard.writeText(code.textContent.trim()).then(copied, copied);
      else copied();
    }
  };

  document.addEventListener("click", function (e) {
    var b = e.target.closest("[data-wl-action]");
    if (b && actions[b.getAttribute("data-wl-action")]) actions[b.getAttribute("data-wl-action")](b);
  });

  // Clicking the dimmed area around a dialog closes it.
  document.addEventListener("mousedown", function (e) {
    if (e.target.matches("[data-wl-modal-wrap]")) closeModal();
    if (e.target.matches("[data-wl-pw-wrap]")) closePassword();
  });

  document.addEventListener("keydown", function (e) {
    var dialog = body.classList.contains("wl-pw-open") ? $("[data-wl-pw-wrap]")
      : body.classList.contains("wl-modal-open") ? modal() : null;
    if (!dialog) {
      if (e.key === "Escape" && !body.classList.contains("wl-post")) endIntro();
      return;
    }
    if (e.key === "Escape") {
      if (body.classList.contains("wl-pw-open")) closePassword(); else closeModal();
    }
    if (e.key === "Tab") { // focus trap
      var f = $$("button, input, a[href]", dialog).filter(function (el) {
        return el.offsetParent !== null && !el.disabled && el.type !== "hidden";
      });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  // ---------- Theme editor ----------
  // Selecting a section in the editor jumps the page to the state where that section shows.
  document.addEventListener("shopify:section:load", function (e) {
    if ($("[data-wl-video]", e.target)) {
      setupFilm();
      if (body.classList.contains("wl-post")) playLoop(); else startIntro();
    }
    if ($("[data-wl-modal]", e.target)) {
      var s = saved();
      if (s) showSuccess(s);
    }
    if ($("[data-wl-lockup]", e.target)) setReopenLabel(!!saved());
  });
  document.addEventListener("shopify:section:select", function (e) {
    var root = e.target;
    if ($("[data-wl-video]", root)) { closeModal(true); startIntro(); return; }
    endIntro({ openModal: false });
    if ($("[data-wl-modal]", root)) openModal();
    else if ($("[data-wl-lockup]", root)) {
      if (body.classList.contains("wl-modal-open")) closeModal();
      else body.classList.add("wl-modal-closed");
    }
  });

  // ---------- Go ----------
  function init() {
    body.classList.add("wl-page");
    setupFilm();
    if (saved()) setReopenLabel(true);

    var st = $("[data-wl-state]");
    var posted = st && st.getAttribute("data-wl-state");
    if (posted === "success") {
      // Returned from a full-page submit (no JS fetch, or after a captcha).
      var emailEl = $("[data-wl-email]");
      var payload = { email: emailEl && emailEl.value, phone: null };
      if (payload.email) store.set(storeKey(), JSON.stringify(payload));
      endIntro({ openModal: false });
      showSuccess(payload);
      openModal();
      return;
    }
    if (posted === "error") { endIntro({ openModal: false }); openModal(); return; }
    if ($("[data-wl-pw-error]")) { endIntro({ openModal: false }); body.classList.add("wl-modal-closed"); openPassword(); return; }

    var film = $("[data-wl-film]");
    var once = film && film.getAttribute("data-intro") === "once";
    if (once && store.get(INTRO_SEEN_KEY)) endIntro({ delay: 400 });
    else startIntro();
  }

  window.V4NWaitlist = { open: openModal, close: closeModal, replay: startIntro, skip: endIntro };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
